import React from "react";
import { _t } from "app/i18n/i18n";
import { Badge } from "react-bootstrap";
import SubscriptionsTag from "components/Subscriptions/SubscriptionsTag/SubscriptionsTag";
import { updateTagsInState, getTagFromState } from "./SubscriptionsCategoryPills.helpers";
import styles from "./SubscriptionsCategoryPills.module.scss";

const catToTranslationIdMap = {
  Categories: "subscribe-categories",
  Analysts: "subscribe-analysts",
  Companies: "subscribe-companies",
  Sectors: "subscribe-sectors",
  Periodicals: "subscribe-periodicals",
  Regions: "subscribe-regions",
  "Report Titles": "subscribe-report-titles",
  "Asset Classes": "subscribe-asset-classes",
  "Anchor Report": "subscribe-anchor-report",
  Webcast: "subscribe-webcast",
  "Special Report": "subscribe-special-report",
  "Report Types": "subscribe-report-types",
  Countries: "subscribe-countries",
  Currency: "subscribe-currencies",
  Theme: "subscribe-themes",
  "Trade Idea": "subscribe-trade-ideas",
};

export default function SubscriptionsCategoryPills({
  category,
  defaultTags,
  selectedSubscriptionTags,
  setSelectedSubscriptionTags,
}) {
  const finalPillContainerStyle = { height: "auto", overflow: "none" };

  const finalCategory = catToTranslationIdMap[category];
  const translatedCategory = _t(finalCategory);

  if (!defaultTags.length) return null;

  return (
    <div className={styles.pillsBlock}>
      <div className={styles.categoryTitle}>
        {translatedCategory}
      </div>

      <div className={styles.pillsContainer} style={finalPillContainerStyle}>
        {defaultTags.map(({ tag: defaultTag }, idx) => {
          const tagFromState = getTagFromState(selectedSubscriptionTags, defaultTag);
          return (
            <SubscriptionsTag
              /* eslint-disable-next-line react/no-array-index-key */
              key={`defaultTag-${idx}`} // This prevents identical keys
              text={defaultTag}
              isActive={tagFromState?.selected}
              onClick={() => {
                updateTagsInState(selectedSubscriptionTags, defaultTag, tagFromState, setSelectedSubscriptionTags);
              }}
            />
          );
        })}
      </div>
    </div>
  );
}
